export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-solid-900.svg?371dbce0dd46bd4d2033eb2334f28580";